<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()"
        v-if="convenio.idSituacaoConvenio != 9">
            Adicionar
        </b-button>
        <aporte-parceiro-form
            operacaoProp="I"
            :convenio="convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aporte-parceiro-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AporteParceiroForm from './AporteParceiroForm'

export default {
    components: {
        AporteParceiroForm
    },

    props: {
        convenio: Object,
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aporteParceiro){
            this.$store.dispatch('addRequest')
            ConveniosServicos.inserirAporteParceiro(aporteParceiro)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Aporte inserido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        }
    }
}
</script>
